import { render, staticRenderFns } from "./category.vue?vue&type=template&id=09d2a594"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d2a594')) {
      api.createRecord('09d2a594', component.options)
    } else {
      api.reload('09d2a594', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=09d2a594", function () {
      api.rerender('09d2a594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/nav/category.vue"
export default component.exports